import { Button, Divider, Form } from 'antd'
import { Flex } from 'antd/lib'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { usePatientTreatmentServiceGetPatientTreatmentPlanAdverseEffectEntryListEndpoint } from 'src/api/queries'
import {
  GetPatientTreatmentPlanResponse,
  TreatmentPlanStatus
} from 'src/api/requests'
import { Text } from 'src/components'
import { formatDate } from 'src/libs'
import { useLocales } from 'src/locales'

import { ReactionsModal } from '../ReactionsModal'

import { ReactionsList } from './ReactionsList'
import { useStyles } from './styles'

type Props = {
  data?: GetPatientTreatmentPlanResponse
}

const textStyle = {
  size: 'xl',
  weight: 600
} as const

export const CollapseDetails = ({ data }: Props) => {
  const { id } = useParams()
  const { t } = useLocales()
  const { styles } = useStyles()

  const [form] = Form.useForm()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const { data: adverseReactions } =
    usePatientTreatmentServiceGetPatientTreatmentPlanAdverseEffectEntryListEndpoint(
      { id: String(id) },
      [String(id)],
      {
        enabled: !!id
      }
    )

  const onModalCancel = () => {
    setIsModalOpen(false)
  }

  const onClick = () => {
    setIsModalOpen(true)
  }

  const isCompleted =
    data?.status === TreatmentPlanStatus.CANCELLED ||
    data?.status === TreatmentPlanStatus.COMPLETED

  return (
    <Flex vertical>
      <Flex gap={48} className={styles.collapseWrapper}>
        <Flex vertical gap={4} className={styles.column}>
          <Text {...textStyle}>{t('treatments.treatment_start_date')}</Text>
          {formatDate(data?.startDate)}
        </Flex>
        <Flex vertical gap={4}>
          <Text {...textStyle}>{t('treatments.next_consultation_date')}</Text>
          {formatDate(data?.endDate)}
        </Flex>
      </Flex>

      {!isCompleted && !!adverseReactions?.data?.length && (
        <>
          <Divider />
          <Flex justify="space-between" className={styles.collapseWrapper}>
            <Text weight={600} size="xl">
              {t('treatments.reactions')}
            </Text>
            <Button
              type="primary"
              onClick={(e) => {
                e.stopPropagation()
                onClick()
              }}
            >
              {t('treatments.report_reactions')}
            </Button>
          </Flex>
        </>
      )}

      <Flex vertical className={styles.collapseWrapper}>
        <Form requiredMark={false} form={form} layout="vertical">
          <Form.List name="events">
            {(fields) => {
              return <ReactionsList fields={fields} form={form} />
            }}
          </Form.List>
        </Form>
      </Flex>

      {isModalOpen && <ReactionsModal id={id} onCancel={onModalCancel} />}
    </Flex>
  )
}
